import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Facebook, Instagram, Youtube, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="bg-black text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* About */}
          <div className="col-span-1 md:col-span-2">
            <img
              src="https://customer-assets.emergentagent.com/job_adventure-leisure/artifacts/2fczd4n3_TNT%20BY%20TVLL.png"
              alt="The Navkar Travels by TVL"
              className="h-20 w-auto mb-4"
            />
            <p className="text-gray-400 mb-4">
              Crafting Journeys, Creating Memories. Your trusted partner for customized
              travel experiences.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/share/1CyU2XnZxq/" target="_blank" rel="noopener noreferrer" aria-label="Facebook" data-testid="footer-facebook-link" className="text-gray-400 hover:text-amber-500 transition-colors">
                <Facebook className="w-6 h-6" />
              </a>
              <a href="https://www.instagram.com/_the_navkar_travels/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-amber-500 transition-colors">
                <Instagram className="w-6 h-6" />
              </a>
              <a href="https://www.youtube.com/@Thenavkartravels" target="_blank" rel="noopener noreferrer" aria-label="YouTube" data-testid="footer-youtube-link" className="text-gray-400 hover:text-amber-500 transition-colors">
                <Youtube className="w-6 h-6" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-amber-500">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => navigate('/')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/instant-itinerary')}
                  data-testid="footer-instant-itinerary-link"
                  className="text-amber-400 hover:text-amber-300 font-semibold transition-colors flex items-center gap-1.5"
                >
                  Instant Itinerary
                  <span className="text-[10px] uppercase tracking-wide bg-amber-500 text-black px-1.5 py-0.5 rounded">AI</span>
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/destinations')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Destinations
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/services')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/about')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/blog')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Travel Blog
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/contact')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Contact Us
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-amber-500">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <Phone className="w-5 h-5 text-amber-500 mr-2 mt-0.5 flex-shrink-0" />
                <div>
                  <a href="tel:+916358846179" className="block text-gray-400 text-sm hover:text-amber-500 transition-colors">+91 63588 46179</a>
                  <a href="tel:+919924546179" className="block text-gray-400 text-sm hover:text-amber-500 transition-colors">+91 99245 46179</a>
                  <a href="tel:+919924646179" className="block text-gray-400 text-sm hover:text-amber-500 transition-colors">+91 99246 46179</a>
                  <a href="tel:+919081846179" className="block text-gray-400 text-sm hover:text-amber-500 transition-colors">+91 90818 46179</a>
                  <p className="text-xs text-gray-500 mt-2">Open daily: 11:00 AM - 11:00 PM</p>
                </div>
              </li>
              <li className="flex items-start">
                <Mail className="w-5 h-5 text-amber-500 mr-2 mt-0.5 flex-shrink-0" />
                <div>
                  <a href="mailto:Info@Thenavkartravels.com" className="text-gray-400 break-all hover:text-amber-500 transition-colors">Info@Thenavkartravels.com</a>
                  <p className="text-xs text-gray-500 mt-1">24/7 Support</p>
                </div>
              </li>
              <li className="flex items-start">
                <MapPin className="w-5 h-5 text-amber-500 mr-2 mt-0.5 flex-shrink-0" />
                <a href="https://share.google/wnPvv83B3tBR31ZJ3" target="_blank" rel="noopener noreferrer" data-testid="footer-address" className="not-italic text-gray-400 text-sm leading-relaxed hover:text-amber-500 transition-colors">
                  The Navkar Travels,<br />
                  Opposite Shreeji Arcade, Adajan,<br />
                  Surat - 395005, Gujarat, India
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400">
            © {new Date().getFullYear()} The Navkar Travels by TVL. All rights reserved.
          </p>
          <button
            onClick={() => navigate('/terms')}
            data-testid="footer-terms-link"
            className="text-gray-400 hover:text-amber-500 transition-colors text-sm mt-2 underline"
          >
            Terms &amp; Conditions
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
